import React from 'react';

import { ReportContent } from '../components/AppLayout';

export const Reports: React.FC = () => {
  return <ReportContent />;
};
